import xhr from './../../utils/xhr';

const api = {
    get: (filters = { pestle: null, companyId: null, payload: null }, sorting = {
        sortBy: "createdDate",
        direction: "DESC"
    }, pagination = {pageSize: -1, pageNumber: -1}) => {
        return xhr.post({
            url: `/api/articles/riskEntity/${filters.companyId}?pageNumber=${pagination.pageNumber}&pageSize=${pagination.pageSize}&sortBy=${sorting.sortBy}&direction=${sorting.direction}`,
            data: { companyId: filters.companyId, ...filters.payload }
        });
    },

    count: (filters = {pestle: null, companyId: null,  payload: null}) => {
        return xhr.post({
            url: `/api/articles/count/riskEntity/${filters.companyId}`,
            data: { companyId: filters.companyId, ...filters.payload }
        });
    }
}

export default api;



// WEBPACK FOOTER //
// ./src/scripts/pages/EntitiesNews/EntitiesNews.api.js